module.exports = __webpack_public_path__ + "img/icons-line-add.f7cbc180.svg";